module.exports = __webpack_public_path__ + "media/images/countryrect/ec-cf6440280d026d9f8bda10698fec8da1.svg";